module.exports = __webpack_public_path__ + "static/virtual-store-12414d7f6a55f44871ff958e454a4dbf.png";